import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const List = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M6 15.333a2 2 0 110 4 2 2 0 010-4zm12.667 1.334a.667.667 0 01.077 1.329l-.077.004H10a.667.667 0 01-.078-1.329l.078-.004h8.667zM6 16.667A.667.667 0 106 18a.667.667 0 000-1.333zM6 10a2 2 0 110 4 2 2 0 010-4zm12.667 1.333a.667.667 0 01.077 1.33l-.077.004H10a.667.667 0 01-.078-1.33l.078-.004h8.667zM6 11.333a.667.667 0 100 1.334.667.667 0 000-1.334zm0-6.666a2 2 0 110 4 2 2 0 010-4zM18.667 6a.667.667 0 01.077 1.329l-.077.004H10a.667.667 0 01-.078-1.329L10 6h8.667zM6 6a.667.667 0 100 1.333A.667.667 0 006 6z"
          id="a-list"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b-list" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#a-list" />
        </mask>
        <use
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#a-list"
        />
        <g
          mask="url(#b-list)"
          fill={props.color || theme.palette.grey600}
          fillOpacity=".6"
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M5.33333329,10.6666667 C4.59733329,10.6666667 3.99999995,11.264 3.99999995,12 C3.99999995,12.736 4.59733329,13.3333333 5.33333329,13.3333333 C6.0693333,13.3333333 6.66666663,12.736 6.66666663,12 C6.66666663,11.264 6.0693333,10.6666667 5.33333329,10.6666667 Z M5.33333329,5.33333329 C4.59733329,5.33333329 3.99999995,5.93066663 3.99999995,6.66666663 C3.99999995,7.40266664 4.59733329,7.99999997 5.33333329,7.99999997 C6.0693333,7.99999997 6.66666663,7.40266664 6.66666663,6.66666663 C6.66666663,5.93066663 6.0693333,5.33333329 5.33333329,5.33333329 Z M5.33333329,16 C4.59733329,16 3.99999995,16.5973334 3.99999995,17.3333334 C3.99999995,18.0693334 4.59733329,18.6666667 5.33333329,18.6666667 C6.0693333,18.6666667 6.66666663,18.0693334 6.66666663,17.3333334 C6.66666663,16.5973334 6.0693333,16 5.33333329,16 Z M10.6666667,7.99999997 L18.6666667,7.99999997 C19.4026667,7.99999997 20,7.4033333 20,6.66666663 C20,5.92999996 19.4026667,5.33333329 18.6666667,5.33333329 L10.6666667,5.33333329 C9.93066665,5.33333329 9.33333332,5.92999996 9.33333332,6.66666663 C9.33333332,7.4033333 9.93066665,7.99999997 10.6666667,7.99999997 Z M18.6666667,10.6666667 L10.6666667,10.6666667 C9.93066665,10.6666667 9.33333332,11.2633333 9.33333332,12 C9.33333332,12.7366667 9.93066665,13.3333333 10.6666667,13.3333333 L18.6666667,13.3333333 C19.4026667,13.3333333 20,12.7366667 20,12 C20,11.2633333 19.4026667,10.6666667 18.6666667,10.6666667 Z M18.6666667,16 L10.6666667,16 C9.93066665,16 9.33333332,16.5966667 9.33333332,17.3333334 C9.33333332,18.07 9.93066665,18.6666667 10.6666667,18.6666667 L18.6666667,18.6666667 C19.4026667,18.6666667 20,18.07 20,17.3333334 C20,16.5966667 19.4026667,16 18.6666667,16 Z"
          id="path-1-list"
        ></path>
      </defs>
      <g
        id="icon-24x24px[16x16px]---line&amp;solid"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Atom/icon/editor/list/solid">
          <mask id="mask-2-list" fill={props.color || theme.palette.grey600}>
            <use xlinkHref="#path-1-list"></use>
          </mask>
          <use
            id="Atom/icon/list"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            xlinkHref="#path-1-list"
          ></use>
          <g
            id="Group"
            mask="url(#mask-2-list)"
            fill={props.color || theme.palette.grey600}
            fillOpacity="0.6"
          >
            <g id="🎨-color">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
